export default __webpack_public_path__ + "static/media/icone_erro.b7e19771.svg";